import { debounce } from "./slider";

const smallQuery = window.matchMedia( '(max-width: 640px)' );
let init = false;

document.querySelectorAll( '.features' ).forEach( section => {
    const wrapper = section.querySelector( '.flex-row' )
    setState( wrapper );
    window.addEventListener( 'resize', debounce( () => setState( wrapper ), 400 ) );
} );

function setState(element) {
    if ( smallQuery.matches && !init ) {
        jQuery( element ).slick( {
            autoplay: true,
            arrows: false,
            infinite: true,
        } );
        init = true;
    } else if (!smallQuery.matches && init) {
        jQuery( element ).slick( 'destroy' );
        init = false;
    }
}